module.exports = __webpack_public_path__ + "assets/img/modal-matte-color-without@2x.png";